import React, { useEffect, useState, useRef } from "react";
import { data } from "./Notes";
import Cards from "./Cards/cards";
import { debounce } from "lodash";

export default function KeyConcepts() {
  const [showCards, setShowCards] = useState(true);
  const [cardButton, setCardButton] = useState("Hide Cards");
  const [showCardbtn, setshowCardbtn] = useState(true);

  const [pageCount, setpageCount] = useState(0);
  const [loadNotes, setLoadNotes] = useState([]);
  const [loadMoreBtn, setloadMoreBtn] = useState(true);

  const [searchInput, setsearchInput] = useState("");

  const loadMoreNotes = () => {
    setpageCount((prevCount) => prevCount + 6);
  };

  useEffect(() => {
    setLoadNotes(() => [...loadNotes, ...data.slice(pageCount, pageCount + 6)]);
  }, [pageCount]);

  useEffect(() => {
    if (data.length - 8 < pageCount) {
      setloadMoreBtn(false);
    }
  }, [pageCount]);

  //   const handleInput = debounce((e) => {
  //     e.preventDefault();
  //     let filterValue = e.target.value;
  //     console.log("Data: ", data.filter((eachNote) => {
  //         eachNote.title.toLowerCase().includes(filterValue.toLowerCase())
  //       }))
  //     setLoadNotes(

  //     );
  //   }, 200);

  // console.log(inputRef.current)

  useEffect(() => {
    if (searchInput) {
      setLoadNotes(
        data.filter(
          (eachNote) =>
            eachNote.title.toLowerCase().includes(searchInput.toLowerCase()) ||
            eachNote.details
              .toString()
              .toLowerCase()
              .includes(searchInput.toLowerCase())
        )
      );
      setloadMoreBtn(false);

      if (loadNotes) {
        setshowCardbtn(false);
      }
    }
  }, [searchInput]);

  const initialState = () => {
    setLoadNotes(() => [...data.slice(0, 6)]);
    setloadMoreBtn(true);
    setshowCardbtn(true);
    setsearchInput("");
  };

  return (
    <div>
      <h2
        style={{
          margin: "1rem",
          textDecoration: "underline",
          color: "cornflowerblue",
          textAlign: "center",
        }}
      >
        Key Points
      </h2>
      <div style={{ textAlign: "justify", width: "70%", margin: "auto" }}>
        <p>
          React is fast, scalable, and simple. You can find few important
          concepts related to Javascript and React. Have a look at the cards.
          <p style={{ color: "tomato" }}>
            Note: Some cards are having sample code.
          </p>
        </p>
      </div>
      {/* <button
        className="btn btn-primary"
        style={{ marginTop: "2px", marginBottom: "50px", backgroundColor:"royalblue", borderRadius: "1rem", }}
        onClick={() => {
          setShowCards((prev) => !prev);
          setloadMoreBtn((prev) =>
            cardButton === "Hide Cards" ? false : true
          );
          setCardButton(
            cardButton === "Show info cards" ? "Hide Cards" : "Show info cards"
          );
        }}
      >
        {cardButton}
      </button> */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          width: "80%",
        }}
      >
        Filter cards:
        <input
          style={{
            padding: "0.2rem",
            margin: "0.4rem",
            width: "30%",
            borderRadius: "0.6rem",
            outline: "none"
          }}
          value={searchInput}
          //   ref={inputRef}
          onChange={(e) => setsearchInput(e.target.value)}
        ></input>
        <button
          className="btn btn-danger"
          style={{ borderRadius: "0.6rem" }}
          onClick={initialState}
        >
          Reset
        </button>
        
      </div>

      {showCards && (
        <div className="card-div-app">
          {loadNotes.map((item) => (
            <Cards
              key={item.id}
              frontSide={item.title}
              backSide={item.details}
              code={item.code}
            />
          ))}
        </div>
      )}
      <div style={{textAlign:"center"}}>
      <div>
        {loadMoreBtn && showCards ? (
          <button
            className="btn btn-primary"
            style={{
              marginTop: "15px",
              marginBottom: "10px",
              backgroundColor: "royalblue",
              borderRadius: "1rem",
            }}
            onClick={() => loadMoreNotes()}
          >
            Load more . . .
          </button>
        ) : (
          ""
        )}
      </div>
      <div>
        {showCardbtn && (
          <button
            style={{
              marginBottom: "40px",
              backgroundColor: "royalblue",
              borderRadius: "1rem",
            }}
            className="btn btn-primary"
            onClick={() => {
              setShowCards((prev) => !prev);
              setCardButton(
                cardButton === "Hide Cards" ? "Show info cards" : "Hide Cards"
              );
            }}
          >
            {cardButton}
          </button>
        )}
      </div>
      </div>
      <div style={{ marginTop: "100px" }}></div>
      {/* <BounceDiv style={{ float: "right", marginRight: "15px" }}>
        <Resume />
      </BounceDiv> */}
    </div>
  );
}
